import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import ApplicationMobile from "../components/Page/ApplicationMobile";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import Contact from "../components/Contact/Contact";
import Clear from "../components/Structure/Clear";

import picture from "./img/application-mobile.jpg";
import config from "../../data/SiteConfig";
import "./page.scss";

export default class ApplicationMobileApp extends Component {
  render() {
    // SEO PURPOSES
    const { slug } = this.props.pathContext;


    const postNode = {
        "frontmatter": {
            "title": "Création d'application mobile iOS et Android",
            "description":  "Integral Service réalise des applications mobiles sur-mesure pour les supports mobiles ou tablettes Android ou iOS.",
            "cover": picture
        }
    };

    let title = "Application mobile";
    let description = "Des applications mobile évolutives !";
    let goto = "En découvrir plus";

    return (
      <div className="webapp-container page-details">
          <Header/>
          <Menu />
          <Helmet 
          title={`Création d'application mobile | ${config.siteTitle}`}
          description = {`Integral Service réalise des applications mobiles sur-mesure pour les supports mobiles ou tablettes Android ou iOS.`}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <HeaderPage title={title} description={description} picture={picture} />
          <ApplicationMobile />
          <Contact />
          <Clear/>
          <SocialLinks postPath={slug} postNode={postNode} />
          <Footer />
      </div>
    );
  }
}
;


// WEBPACK FOOTER //
// ./src/pages/application-mobile.jsx